import React from 'react'

const CommentsIcon = ({ width = 14, height = 13, fill = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 13" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.97 10.6667L0 13V0.666667C0 0.489856 0.0702379 0.320286 0.195262 0.195262C0.320286 0.0702379 0.489856 0 0.666667 0H12.6667C12.8435 0 13.013 0.0702379 13.1381 0.195262C13.2631 0.320286 13.3333 0.489856 13.3333 0.666667V10C13.3333 10.1768 13.2631 10.3464 13.1381 10.4714C13.013 10.5964 12.8435 10.6667 12.6667 10.6667H2.97ZM2.50867 9.33333H12V1.33333H1.33333V10.2567L2.50867 9.33333ZM6 4.66667H7.33333V6H6V4.66667ZM3.33333 4.66667H4.66667V6H3.33333V4.66667ZM8.66667 4.66667H10V6H8.66667V4.66667Z"
        fill={fill}
      />
    </svg>
  )
}

export default CommentsIcon
